import React from 'react';
import { Frame, Navigation } from '@shopify/polaris';
import { HomeIcon, ProductIcon, SettingsIcon } from '@shopify/polaris-icons';
import { useNavigate, useLocation } from 'react-router-dom';

export default function AppFrame({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationMarkup = (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            url: '/',
            label: 'Dashboard',
            icon: HomeIcon,
            selected: location.pathname === '/',
            onClick: () => navigate('/'),
          },
          {
            url: '/products',
            label: 'Products',
            icon: ProductIcon,
            selected: location.pathname === '/products',
            onClick: () => navigate('/products'),
          },
          {
            url: '/settings',
            label: 'Settings',
            icon: SettingsIcon,
            selected: location.pathname === '/settings',
            onClick: () => navigate('/settings'),
          },
        ]}
      />
    </Navigation>
  );

  return (
    <Frame navigation={navigationMarkup}>
      {children}
    </Frame>
  );
}
